import React from 'react'
import { ElfsightLinkedInFeed } from './ElfsightLinkedInFeed'

const LinkedInComponent = () => {
  return (
    <section className="relative py-24 bg-neutral-muted sm:py-32">
      <div className="px-6 mx-auto max-w-7xl lg:px-8">
        <h2 className="mb-4 text-center text-4xl font-light leading-tight tracking-tight text-text-primary sm:text-5xl lg:text-[52px] lg:leading-tight">
          Follow our LinkedIn insights
        </h2>
        <h3 className="mb-16 text-lg font-light leading-relaxed tracking-tight text-center text-text-primary text-h3">
          Expert information and commentary on climate adaptation and spatial risk analysis.
        </h3>

        <div className="relative px-6 py-10">
          <ElfsightLinkedInFeed />
        </div>
      </div>
    </section>
  )
}
export default LinkedInComponent
